import React from "react";
import {Props, useBehaviour} from "./useBehaviour";
import {View} from "./view";

export const SchemePreview = (props: Props) => {
  return (
    <View {...useBehaviour(props)} />
  );
};